export function trackUmamiEvent(event) {
  window.umami.track(event);
}
